import InputText from '@/components/Form/InputText.jsx'

import {
    PropertiesController,
    usePropertiesController,
} from './PropertiesController.jsx'

export default function PropertiesControllerText({
    className,
    style,
    disabled,
    hidden,
    label,
    labelSuffix,
    prop,
    readOnly,
    required,
    value,
    ...props
}) {
    const p = usePropertiesController({
        disabled,
        hidden,
        label,
        prop,
        readOnly,
        required,
        value,
    })

    return (
        <PropertiesController
            className={className}
            style={style}
            error={p.error}
            hidden={p.hidden}
            label={p.label}
            labelSuffix={labelSuffix}
            required={p.required}
        >
            <InputText
                allowClear
                disabled={p.disabled}
                readOnly={p.readOnly}
                value={p.value}
                onBlur={p.onBlur}
                onChange={p.onChange}
                onFocus={p.onFocus}
                {...props}
            />
        </PropertiesController>
    )
}
